class EmailExporterImproved {
  static generateHTML(blocks, settings) {
    const { width, backgroundColor, fontFamily, fontSize, padding } = settings;
    
    const sortedBlocks = [...blocks].sort((a, b) => a.position - b.position);
    const blocksHTML = sortedBlocks.map(block => this.renderBlock(block, settings)).join('\n');
    
    return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="format-detection" content="telephone=no" />
    <meta name="format-detection" content="date=no" />
    <meta name="format-detection" content="address=no" />
    <meta name="format-detection" content="email=no" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title>Email Template</title>
    
    <!--[if gte mso 9]>
    <xml>
        <o:OfficeDocumentSettings>
            <o:AllowPNG/>
            <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
    </xml>
    <![endif]-->
    
    <!--[if gte mso 9]>
    <style type="text/css">
        table { border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
        .outlook-group-fix { width: 100% !important; }
    </style>
    <![endif]-->
    
    <style type="text/css">
        /* CLIENT-SPECIFIC STYLES */
        body, table, td, p, a, li, blockquote { 
            -webkit-text-size-adjust: 100%; 
            -ms-text-size-adjust: 100%; 
        }
        table, td { 
            mso-table-lspace: 0pt; 
            mso-table-rspace: 0pt; 
            border-collapse: collapse;
        }
        img { 
            -ms-interpolation-mode: bicubic; 
            border: 0; 
            height: auto; 
            line-height: 100%; 
            outline: none; 
            text-decoration: none; 
            display: block;
        }
        
        /* RESET STYLES */
        body { 
            height: 100% !important; 
            margin: 0 !important; 
            padding: 0 !important; 
            width: 100% !important; 
            font-family: ${fontFamily || 'Arial, Helvetica, sans-serif'};
            font-size: ${fontSize || 14}px;
            line-height: 1.4;
        }
        
        /* Prevent auto-linking */
        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
        }
        
        /* Gmail Blue Links Fix */
        u + .body a {
            color: inherit;
            text-decoration: none;
            font-size: inherit;
            font-family: inherit;
            font-weight: inherit;
            line-height: inherit;
        }
        
        /* Samsung Mail Blue Links Fix */
        #MessageViewBody a {
            color: inherit;
            text-decoration: none;
            font-size: inherit;
            font-family: inherit;
            font-weight: inherit;
            line-height: inherit;
        }
        
        /* MOBILE STYLES */
        @media only screen and (max-width: 600px) {
            .email-container { 
                width: 100% !important; 
                max-width: 100% !important;
            }
            .mobile-center {
                text-align: center !important;
            }
            .mobile-hide {
                display: none !important;
                max-height: 0 !important;
                overflow: hidden !important;
                mso-hide: all !important;
            }
            .mobile-stack {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                direction: ltr !important;
            }
            .mobile-stack-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                direction: ltr !important;
            }
            .mobile-text-adjust {
                font-size: 16px !important;
                line-height: 1.4 !important;
            }
            .mobile-heading-adjust {
                font-size: 24px !important;
                line-height: 1.2 !important;
            }
            .mobile-button {
                width: auto !important;
                padding: 12px 20px !important;
                font-size: 16px !important;
            }
            .mobile-image {
                width: 100% !important;
                max-width: 100% !important;
                height: auto !important;
            }
        }
        
        /* DARK MODE STYLES */
        @media (prefers-color-scheme: dark) {
            .dark-mode-bg {
                background-color: #1a1a1a !important;
            }
            .dark-mode-text {
                color: #ffffff !important;
            }
            .dark-mode-secondary-text {
                color: #cccccc !important;
            }
        }
    </style>
</head>
<body style="margin: 0; padding: 0; background-color: #f5f5f5; font-family: ${fontFamily || 'Arial, Helvetica, sans-serif'}; font-size: ${fontSize || 14}px; line-height: 1.4; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
    
    <!-- PREVIEW TEXT (скрытый текст для превью) -->
    <div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: transparent;">
        Email preview text...
    </div>
    
    <!-- WRAPPER TABLE для Outlook -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="width: 100%;" bgcolor="#f5f5f5">
        <tr>
            <td>
    <![endif]-->
    
    <!-- MAIN WRAPPER -->
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #f5f5f5; margin: 0; padding: 0;">
        <tr>
            <td align="center" style="padding: 20px 10px;">
                
                <!-- EMAIL CONTAINER -->
                <!--[if mso | IE]>
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="${width || 600}" style="width: ${width || 600}px;" bgcolor="${backgroundColor || '#ffffff'}">
                    <tr>
                        <td style="padding: ${padding || 20}px;">
                <![endif]-->
                
                <table class="email-container" align="center" border="0" cellpadding="0" cellspacing="0" width="${width || 600}" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; max-width: ${width || 600}px; width: 100%; background-color: ${backgroundColor || '#ffffff'}; margin: 0 auto;">
                    <tr>
                        <td style="padding: ${padding || 20}px;">
                            ${blocksHTML}
                        </td>
                    </tr>
                </table>
                
                <!--[if mso | IE]>
                        </td>
                    </tr>
                </table>
                <![endif]-->
                
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->
    
</body>
</html>`;
  }

  static renderBlock(block, globalSettings = {}) {
    const { type, data } = block;

    switch (type) {
      case 'text':
        return this.renderTextBlock(data, globalSettings);
      case 'heading':
        return this.renderHeadingBlock(data, globalSettings);
      case 'image':
        return this.renderImageBlock(data, globalSettings);
      case 'button':
        return this.renderButtonBlock(data, globalSettings);
      case 'divider':
        return this.renderDividerBlock(data, globalSettings);
      case 'spacer':
        return this.renderSpacerBlock(data, globalSettings);
      case 'list':
        return this.renderListBlock(data, globalSettings);
      case 'hero':
        return this.renderHeroBlock(data, globalSettings);
      case 'footer':
        return this.renderFooterBlock(data, globalSettings);
      case 'unsubscribe':
        return this.renderUnsubscribeBlock(data, globalSettings);
      case 'columns':
      case 'columns-3':
        return this.renderColumnsBlock(data, globalSettings);
      case 'container':
        return this.renderContainerBlock(data, globalSettings);
      case 'testimonial':
        return this.renderTestimonialBlock(data, globalSettings);
      case 'product':
        return this.renderProductBlock(data, globalSettings);
      case 'event':
        return this.renderEventBlock(data, globalSettings);
      case 'social-icons':
        return this.renderSocialIconsBlock(data, globalSettings);
      case 'contactUs':
        return this.renderContactUsBlock(data, globalSettings);
      default:
        console.warn('⚠️ Unsupported block type:', type);
        return `<!-- Unsupported block type: ${type} -->`;
    }
  }

  // УЛУЧШЕННЫЙ TEXT BLOCK - полностью inline стили
  static renderTextBlock(data, globalSettings) {
    const {
      content = '',
      fontSize = 16,
      color = '#333333',
      fontWeight = 'normal',
      fontStyle = 'normal',
      textDecoration = 'none',
      textAlign = 'left',
      lineHeight = 1.5,
      marginTop = 0,
      marginBottom = 15,
      padding = 10,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif',
      backgroundColor = 'transparent'
    } = data;

    const lineHeightValue = lineHeight > 3 ? `${lineHeight}px` : lineHeight;

    return `
    <!-- TEXT BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="padding: ${padding}px;">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="padding: ${padding}px; font-family: ${fontFamily}; font-size: ${fontSize}px; color: ${color}; font-weight: ${fontWeight}; font-style: ${fontStyle}; text-decoration: ${textDecoration}; text-align: ${textAlign}; line-height: ${lineHeightValue}; background-color: ${backgroundColor}; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;" class="mobile-text-adjust">
                ${content.replace(/\n/g, '<br>')}
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // УЛУЧШЕННЫЙ HEADING BLOCK
  static renderHeadingBlock(data, globalSettings) {
    const {
      content = '',
      level = 'h2',
      fontSize = 24,
      color = '#333333',
      fontWeight = 'bold',
      fontStyle = 'normal',
      textDecoration = 'none',
      textAlign = 'left',
      marginTop = 20,
      marginBottom = 15,
      padding = 10,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    return `
    <!-- HEADING BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="padding: ${padding}px;">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="padding: ${padding}px;" class="mobile-heading-adjust">
                <${level} style="margin: 0; padding: 0; font-family: ${fontFamily}; font-size: ${fontSize}px; color: ${color}; font-weight: ${fontWeight}; font-style: ${fontStyle}; text-decoration: ${textDecoration}; text-align: ${textAlign}; line-height: 1.2; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${content}
                </${level}>
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // УЛУЧШЕННЫЙ IMAGE BLOCK
  static renderImageBlock(data, globalSettings) {
    const {
      src = '',
      alt = '',
      width = '100%',
      height = 'auto',
      alignment = 'center',
      borderRadius = 0,
      link = '',
      marginTop = 10,
      marginBottom = 10,
    } = data;

    if (!src) return '';

    // Определяем width для Outlook
    const widthValue = typeof width === 'string' && width.includes('%') ? width : `${width}px`;
    const outlookWidth = typeof width === 'number' ? width : 600;

    const imageStyle = `width: ${widthValue}; max-width: 100%; height: ${height === 'auto' ? 'auto' : height + 'px'}; display: block; border: 0; line-height: 100%; outline: none; text-decoration: none; border-radius: ${borderRadius}px; -ms-interpolation-mode: bicubic;`;
    
    const imageElement = `<img src="${src}" alt="${alt}" style="${imageStyle}" class="mobile-image" width="${outlookWidth}" ${height !== 'auto' ? `height="${height}"` : ''}>`;
    const content = link ? `<a href="${link}" style="display: block; text-decoration: none;">${imageElement}</a>` : imageElement;

    return `
    <!-- IMAGE BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td align="${alignment}">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td align="${alignment}" style="padding: 0;">
                ${content}
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // УЛУЧШЕННЫЙ BUTTON BLOCK с VML поддержкой для Outlook
  static renderButtonBlock(data, globalSettings) {
    const {
      text = 'Click Here',
      link = '#',
      backgroundColor = '#007bff',
      color = '#ffffff',
      borderRadius = 5,
      padding = '12px 24px',
      fontSize = 16,
      fontWeight = 'bold',
      alignment = 'center',
      marginTop = 15,
      marginBottom = 15,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    const paddingArray = padding.split(' ');
    const verticalPadding = parseInt(paddingArray[0]) || 12;
    const horizontalPadding = parseInt(paddingArray[1]) || 24;
    
    // Вычисляем высоту кнопки для VML
    const buttonHeight = (verticalPadding * 2) + fontSize + 4;
    const arcSize = Math.round((borderRadius / buttonHeight) * 100);

    return `
    <!-- BUTTON BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td align="${alignment}" style="padding-top: ${marginTop}px; padding-bottom: ${marginBottom}px;">
                <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${link}" style="height: ${buttonHeight}px; v-text-anchor: middle; width: auto;" arcsize="${arcSize}%" stroke="f" fillcolor="${backgroundColor}">
                    <w:anchorlock/>
                    <center style="color: ${color}; font-family: ${fontFamily}; font-size: ${fontSize}px; font-weight: ${fontWeight}; text-decoration: none;">
                        ${text}
                    </center>
                </v:roundrect>
            </td>
        </tr>
    </table>
    <![endif]-->
    
    <!--[if !mso]><!-->
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td align="${alignment}">
                <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td align="center" style="background-color: ${backgroundColor}; border-radius: ${borderRadius}px;">
                            <a href="${link}" target="_blank" style="display: inline-block; padding: ${verticalPadding}px ${horizontalPadding}px; font-family: ${fontFamily}; font-size: ${fontSize}px; font-weight: ${fontWeight}; color: ${color}; text-decoration: none; border-radius: ${borderRadius}px; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;" class="mobile-button">
                                ${text}
                            </a>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
    <!--<![endif]-->`;
  }

  // УЛУЧШЕННЫЙ DIVIDER BLOCK
  static renderDividerBlock(data, globalSettings) {
    const {
      height = 1,
      color = '#dddddd',
      style = 'solid',
      width = '100%',
      marginTop = 20,
      marginBottom = 20,
    } = data;

    const widthValue = typeof width === 'string' && width.includes('%') ? width : `${width}px`;

    return `
    <!-- DIVIDER BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="padding-top: ${marginTop}px; padding-bottom: ${marginBottom}px;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="${width === '100%' ? '100%' : width}">
                    <tr>
                        <td style="height: ${height}px; line-height: ${height}px; font-size: ${height}px; border-top: ${height}px ${style} ${color};">&nbsp;</td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
    <![endif]-->
    
    <!--[if !mso]><!-->
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td align="center">
                <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: ${widthValue}; margin: 0 auto;">
                    <tr>
                        <td style="height: ${height}px; line-height: ${height}px; font-size: ${height}px; border-top: ${height}px ${style} ${color};">&nbsp;</td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
    <!--<![endif]-->`;
  }

  // SPACER BLOCK
  static renderSpacerBlock(data, globalSettings) {
    const { height = 30 } = data;

    return `
    <!-- SPACER BLOCK -->
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        <tr>
            <td style="height: ${height}px; line-height: ${height}px; font-size: ${height}px;">&nbsp;</td>
        </tr>
    </table>`;
  }

  // HERO BLOCK
  static renderHeroBlock(data, globalSettings) {
    const button = data.button || {};
    const title = data.title || 'Hero Title';
    const subtitle = data.subtitle || data.description || '';
    const backgroundImage = data.backgroundImage || '';
    const backgroundColor = data.backgroundColor || '#f8f9fa';
    const titleColor = data.titleColor || data.textColor || '#333333';
    const subtitleColor = data.subtitleColor || data.descriptionColor || data.textColor || '#666666';
    const titleFontSize = data.titleFontSize || data.titleSize || 32;
    const subtitleFontSize = data.descriptionFontSize || data.subtitleSize || 18;
    const textAlign = data.textAlign || data.alignment || 'center';
    const padding = typeof data.padding === 'number' ? `${data.padding}px` : (data.padding || '60px 20px');
    const marginTop = data.marginTop || 0;
    const marginBottom = data.marginBottom || 0;
    const buttonText = data.buttonText ?? button.text ?? '';
    const buttonLink = data.buttonLink ?? button.link ?? '#';
    const buttonBackgroundColor = data.buttonBackgroundColor || '#007bff';
    const buttonTextColor = data.buttonTextColor || '#ffffff';
    const showButton = data.showButton ?? button.show ?? true;
    const fontFamily = data.fontFamily || globalSettings.fontFamily || 'Arial, Helvetica, sans-serif';

    const backgroundStyle = backgroundImage
      ? `background-image: url(${backgroundImage}); background-size: cover; background-position: center; background-repeat: no-repeat;`
      : `background-color: ${backgroundColor};`;

    const buttonHTML = showButton && buttonText ? `
                <table border="0" cellpadding="0" cellspacing="0" style="margin-top: 20px;">
                    <tr>
                        <td align="${textAlign}">
                            <a href="${buttonLink}" style="display: inline-block; padding: 12px 30px; font-family: ${fontFamily}; font-size: 16px; color: ${buttonTextColor}; background-color: ${buttonBackgroundColor}; text-decoration: none; border-radius: 5px; font-weight: bold; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                                ${buttonText}
                            </a>
                        </td>
                    </tr>
                </table>` : '';

    return `
    <!-- HERO BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="${backgroundStyle} padding: ${padding}; text-align: ${textAlign};">
    <![endif]-->

    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="${backgroundStyle} padding: ${padding}; text-align: ${textAlign};">
                <h1 style="margin: 0 0 10px 0; padding: 0; font-family: ${fontFamily}; font-size: ${titleFontSize}px; color: ${titleColor}; font-weight: bold; text-align: ${textAlign}; line-height: 1.2; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${title}
                </h1>
                ${subtitle ? `
                <p style="margin: 0; padding: 0; font-family: ${fontFamily}; font-size: ${subtitleFontSize}px; color: ${subtitleColor}; text-align: ${textAlign}; line-height: 1.4; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${subtitle}
                </p>
                ` : ''}
                ${buttonHTML}
            </td>
        </tr>
    </table>

    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // COLUMNS BLOCK с улучшенной поддержкой Outlook
  static renderColumnsBlock(data, globalSettings) {
    const {
      columns = 2,
      columnGap = 20,
      leftWidth = '50%',
      rightWidth = '50%',
      columnWidths = ['33.33%', '33.33%', '33.33%'],
      leftContent = [],
      rightContent = [],
      content = [[], [], []],
      marginTop = 15,
      marginBottom = 15,
      padding = 10,
      backgroundColor = 'transparent',
    } = data;

    let columnsHTML = '';

    if (columns === 2) {
      const leftHTML = leftContent.map(item => this.renderBlock(item, globalSettings)).join('\n');
      const rightHTML = rightContent.map(item => this.renderBlock(item, globalSettings)).join('\n');

      // Вычисляем ширину колонок для Outlook
      const leftWidthPercent = parseInt(leftWidth.replace('%', ''));
      const rightWidthPercent = parseInt(rightWidth.replace('%', ''));

      columnsHTML = `
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
            <tr>
                <td width="${leftWidthPercent}%" style="vertical-align: top; padding-right: ${columnGap/2}px;" class="mobile-stack-column">
                    ${leftHTML}
                </td>
                <td width="${rightWidthPercent}%" style="vertical-align: top; padding-left: ${columnGap/2}px;" class="mobile-stack-column">
                    ${rightHTML}
                </td>
            </tr>
        </table>`;
    } else {
      // Обрабатываем 3+ колонки
      const columnsData = content.map((columnContent, index) => {
        const columnHTML = columnContent.map(item => this.renderBlock(item, globalSettings)).join('\n');
        const width = columnWidths[index] || '33.33%';
        const widthPercent = parseInt(width.replace('%', ''));
        const paddingLeft = index > 0 ? `padding-left: ${columnGap}px;` : '';
        
        return {
          width: widthPercent,
          html: columnHTML,
          padding: paddingLeft
        };
      });

      const columnCells = columnsData.map(col => 
        `<td width="${col.width}%" style="vertical-align: top; ${col.padding}" class="mobile-stack-column">${col.html}</td>`
      ).join('\n');

      columnsHTML = `
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
            <tr>
                ${columnCells}
            </tr>
        </table>`;
    }

    return `
    <!-- COLUMNS BLOCK -->
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="padding: ${padding}px; background-color: ${backgroundColor};">
                ${columnsHTML}
            </td>
        </tr>
    </table>`;
  }

  // UNSUBSCRIBE BLOCK
  static renderUnsubscribeBlock(data, globalSettings) {
    const {
      text = 'If you no longer wish to receive these emails, you can',
      buttonText = 'Unsubscribe',
      textColor = '#666666',
      buttonColor = '#007bff',
      buttonTextColor = '#ffffff',
      fontSize = 12,
      backgroundColor = 'transparent',
      padding = 20,
      marginTop = 20,
      marginBottom = 20,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    return `
    <!-- UNSUBSCRIBE BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="padding: ${padding}px; background-color: ${backgroundColor}; text-align: center;">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="padding: ${padding}px; background-color: ${backgroundColor}; text-align: center;">
                <p style="margin: 0 0 10px 0; padding: 0; font-family: ${fontFamily}; font-size: ${fontSize}px; color: ${textColor}; text-align: center; line-height: 1.4; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${text}
                </p>
                <a href="{{unsubscribe_url}}" style="display: inline-block; padding: 8px 16px; font-family: ${fontFamily}; font-size: ${fontSize}px; color: ${buttonTextColor}; background-color: ${buttonColor}; text-decoration: none; border-radius: 3px; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${buttonText}
                </a>
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // LIST BLOCK
  static renderListBlock(data, globalSettings) {
    const {
      items = [],
      listType = 'bullet',
      fontSize = 16,
      color = '#333333',
      lineHeight = 1.6,
      spacing = 8,
      marginTop = 15,
      marginBottom = 15,
      padding = 10,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    const listStyle = listType === 'numbered' ? 'decimal' : listType === 'none' ? 'none' : 'disc';
    const paddingLeft = listType === 'none' ? '0' : '20px';

    const itemsHTML = items.map(item => 
      `<li style="margin-bottom: ${spacing}px; font-family: ${fontFamily}; font-size: ${fontSize}px; color: ${color}; line-height: ${lineHeight}; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">${item}</li>`
    ).join('');

    return `
    <!-- LIST BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="padding: ${padding}px;">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="padding: ${padding}px;">
                <ul style="list-style: ${listStyle}; padding-left: ${paddingLeft}; margin: 0; font-family: ${fontFamily}; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${itemsHTML}
                </ul>
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // FOOTER BLOCK
  static renderFooterBlock(data, globalSettings) {
    const {
      companyName = '',
      address = '',
      phone = '',
      email = '',
      website = '',
      unsubscribeText = '',
      unsubscribeLink = '#',
      backgroundColor = '#f8f9fa',
      textColor = '#666666',
      fontSize = 12,
      padding = '30px 20px',
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    const contactInfo = [];
    if (phone) contactInfo.push(`📞 <a href="tel:${phone}" style="color: ${textColor}; text-decoration: none;">${phone}</a>`);
    if (email) contactInfo.push(`✉️ <a href="mailto:${email}" style="color: ${textColor}; text-decoration: none;">${email}</a>`);
    if (website) contactInfo.push(`🌐 <a href="${website}" target="_blank" style="color: ${textColor}; text-decoration: none;">${website.replace(/^https?:\/\//, '')}</a>`);

    return `
    <!-- FOOTER BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="width: 600px;">
        <tr>
            <td style="line-height: 0px; font-size: 0px; mso-line-height-rule: exactly;">
    <![endif]-->
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: ${backgroundColor}; margin: 0;">
        <tr>
            <td style="padding: ${padding}; text-align: center;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%">
                    ${companyName ? `
                    <tr>
                        <td style="padding-bottom: 8px;">
                            <p style="margin: 0; font-family: ${fontFamily}; font-size: ${fontSize}px; font-weight: bold; color: ${textColor}; text-align: center;">
                                ${companyName}
                            </p>
                        </td>
                    </tr>
                    ` : ''}
                    
                    ${address ? `
                    <tr>
                        <td style="padding-bottom: 15px;">
                            <p style="margin: 0; font-family: ${fontFamily}; font-size: ${fontSize}px; color: ${textColor}; text-align: center; line-height: 1.5;">
                                ${address}
                            </p>
                        </td>
                    </tr>
                    ` : ''}
                    
                    ${contactInfo.length > 0 ? `
                    <tr>
                        <td style="padding-bottom: 15px;">
                            <p style="margin: 0; font-family: ${fontFamily}; font-size: ${fontSize}px; color: ${textColor}; text-align: center; line-height: 1.5;">
                                ${contactInfo.join('<br>')}
                            </p>
                        </td>
                    </tr>
                    ` : ''}
                    
                    ${unsubscribeText ? `
                    <tr>
                        <td>
                            <p style="margin: 0; font-family: ${fontFamily}; font-size: ${fontSize}px; text-align: center;">
                                <a href="${unsubscribeLink}" style="color: ${textColor}; text-decoration: underline;">
                                    ${unsubscribeText}
                                </a>
                            </p>
                        </td>
                    </tr>
                    ` : ''}
                </table>
            </td>
        </tr>
    </table>
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // CONTAINER BLOCK
  static renderContainerBlock(data, globalSettings) {
    const {
      content = [],
      backgroundColor = 'transparent',
      padding = 20,
      marginTop = 15,
      marginBottom = 15,
    } = data;

    const contentHTML = content.map(item => this.renderBlock(item, globalSettings)).join('\n');

    return `
    <!-- CONTAINER BLOCK -->
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px;">
                ${contentHTML}
            </td>
        </tr>
    </table>`;
  }

  // TESTIMONIAL BLOCK
  static renderTestimonialBlock(data, globalSettings) {
    const {
      quote = '',
      author = '',
      position = '',
      companyName = '',
      authorImage = '',
      avatar = '',
      quoteFontSize = 16,
      authorFontSize = 14,
      quoteColor = '#333333',
      authorColor = '#666666',
      backgroundColor = '#f8f9fa',
      padding = 30,
      marginTop = 20,
      marginBottom = 20,
      borderRadius = 8,
      alignment = 'center',
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif',
    } = data;

    const imageSrc = authorImage || avatar;
    const avatarHTML = imageSrc ? `
      <img src="${imageSrc}" alt="${author}" style="width: 60px; height: 60px; border-radius: 50%; margin: 0 auto 15px auto; display: block; border: 0; -ms-interpolation-mode: bicubic;" width="60" height="60">
    ` : '';

    return `
    <!-- TESTIMONIAL BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px; text-align: ${alignment};">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px; text-align: ${alignment}; border-radius: ${borderRadius}px;">
                ${avatarHTML}
                <p style="margin: 0 0 15px 0; padding: 0; font-family: ${fontFamily}; font-size: ${quoteFontSize}px; color: ${quoteColor}; font-style: italic; line-height: 1.5; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    "${quote}"
                </p>
                <p style="margin: 0; padding: 0; font-family: ${fontFamily}; font-size: ${authorFontSize}px; color: ${authorColor}; font-weight: bold; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${author}
                </p>
                ${position ? `
                <p style="margin: 5px 0 0 0; padding: 0; font-family: ${fontFamily}; font-size: ${Math.max(authorFontSize - 2, 10)}px; color: ${authorColor}; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${position}
                </p>
                ` : ''}
                ${companyName ? `
                <p style="margin: 5px 0 0 0; padding: 0; font-family: ${fontFamily}; font-size: ${Math.max(authorFontSize - 2, 10)}px; color: ${authorColor}; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${companyName}
                </p>
                ` : ''}
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // PRODUCT BLOCK
  static renderProductBlock(data, globalSettings) {
    const {
      name = '',
      description = '',
      price = '',
      image = '',
      buttonText = 'Buy Now',
      buttonLink = '#',
      backgroundColor = '#ffffff',
      padding = 20,
      marginTop = 20,
      marginBottom = 20,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    const imageHTML = image ? `
      <img src="${image}" alt="${name}" style="width: 100%; max-width: 200px; height: auto; display: block; margin: 0 auto 15px; border: 0; -ms-interpolation-mode: bicubic;" class="mobile-image">
    ` : '';

    return `
    <!-- PRODUCT BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px; text-align: center;">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px; text-align: center;">
                ${imageHTML}
                <h3 style="margin: 0 0 10px 0; padding: 0; font-family: ${fontFamily}; font-size: 20px; color: #333; font-weight: bold; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${name}
                </h3>
                <p style="margin: 0 0 10px 0; padding: 0; font-family: ${fontFamily}; font-size: 14px; color: #666; line-height: 1.4; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${description}
                </p>
                <p style="margin: 0 0 15px 0; padding: 0; font-family: ${fontFamily}; font-size: 18px; color: #333; font-weight: bold; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${price}
                </p>
                <a href="${buttonLink}" style="display: inline-block; padding: 12px 24px; font-family: ${fontFamily}; font-size: 16px; color: #ffffff; background-color: #007bff; text-decoration: none; border-radius: 5px; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${buttonText}
                </a>
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // EVENT BLOCK
  static renderEventBlock(data, globalSettings) {
    const {
      title = '',
      date = '',
      time = '',
      location = '',
      description = '',
      buttonText = 'Register',
      buttonLink = '#',
      backgroundColor = '#ffffff',
      padding = 20,
      marginTop = 20,
      marginBottom = 20,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    return `
    <!-- EVENT BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px;">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px;">
                <h3 style="margin: 0 0 15px 0; padding: 0; font-family: ${fontFamily}; font-size: 22px; color: #333; font-weight: bold; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${title}
                </h3>
                <p style="margin: 0 0 10px 0; padding: 0; font-family: ${fontFamily}; font-size: 16px; color: #666; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    📅 ${date} ${time ? `at ${time}` : ''}
                </p>
                ${location ? `
                <p style="margin: 0 0 15px 0; padding: 0; font-family: ${fontFamily}; font-size: 16px; color: #666; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    📍 ${location}
                </p>
                ` : ''}
                <p style="margin: 0 0 20px 0; padding: 0; font-family: ${fontFamily}; font-size: 14px; color: #333; line-height: 1.4; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${description}
                </p>
                <a href="${buttonLink}" style="display: inline-block; padding: 12px 24px; font-family: ${fontFamily}; font-size: 16px; color: #ffffff; background-color: #28a745; text-decoration: none; border-radius: 5px; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
                    ${buttonText}
                </a>
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // SOCIAL ICONS BLOCK
  static renderSocialIconsBlock(data, globalSettings) {
    const {
      icons = [],
      size = 32,
      spacing = 10,
      alignment = 'center',
      marginTop = 20,
      marginBottom = 20,
      padding = 10
    } = data;

    const iconsHTML = icons.map(icon => `
      <a href="${icon.link || '#'}" style="display: inline-block; margin: 0 ${spacing/2}px; text-decoration: none;">
        <img src="${icon.icon}" alt="${icon.name}" style="width: ${size}px; height: ${size}px; display: block; border: 0; -ms-interpolation-mode: bicubic;" width="${size}" height="${size}">
      </a>
    `).join('');

    return `
    <!-- SOCIAL ICONS BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td align="${alignment}" style="padding: ${padding}px;">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td align="${alignment}" style="padding: ${padding}px;">
                ${iconsHTML}
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // CONTACT US BLOCK - УЛУЧШЕННАЯ ВЕРСИЯ с поддержкой массива contacts
  static renderContactUsBlock(data, globalSettings) {
    const {
      title = 'Contact Us',
      contacts = [],
      backgroundColor = '#ffffff',
      titleColor = '#333333',
      nameColor = '#333333',
      positionColor = '#666666',
      descriptionColor = '#666666',
      contactColor = '#007bff',
      borderColor = '#e0e0e0',
      titleFontSize = 28,
      nameFontSize = 18,
      positionFontSize = 14,
      descriptionFontSize = 14,
      contactFontSize = 14,
      alignment = 'center',
      cardsPerRow = 2,
      cardSpacing = 20,
      padding = 30,
      marginTop = 20,
      marginBottom = 20,
      borderRadius = 8,
      fontFamily = globalSettings.fontFamily || 'Arial, Helvetica, sans-serif'
    } = data;

    // Убеждаемся, что contacts является массивом
    const contactsArray = Array.isArray(contacts) ? contacts : [];

    const titleHTML = title ? `
    <h2 style="
      font-size: ${titleFontSize}px;
      color: ${titleColor};
      text-align: ${alignment};
      margin: 0 0 30px 0;
      font-weight: bold;
      font-family: ${fontFamily};
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    ">${title}</h2>` : '';

    const contactCards = contactsArray.map(contact => {
      const avatarHTML = contact.avatar && contact.avatar.trim() ? `
        <div style="text-align: center; margin-bottom: 15px;">
          <img src="${contact.avatar}" alt="${contact.fullName || 'Contact'}" style="
            width: 80px;
            height: 80px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid ${borderColor};
            display: block;
            margin: 0 auto;
            -ms-interpolation-mode: bicubic;
          ">
        </div>
      ` : `
        <div style="
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background-color: #e0e0e0;
          margin: 0 auto 15px auto;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #666;
          font-size: 14px;
          font-weight: bold;
          border: 2px solid ${borderColor};
        ">${(contact.fullName || 'Contact').charAt(0).toUpperCase()}</div>
      `;

      const phoneHTML = contact.phone ? `
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 8px;">
          <span style="margin-right: 8px;">📞</span>
          <span style="color: ${contactColor}; font-size: ${contactFontSize}px;">${contact.phone}</span>
        </div>
      ` : '';

      const emailHTML = contact.email ? `
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 8px;">
          <span style="margin-right: 8px;">✉️</span>
          <span style="color: ${contactColor}; font-size: ${contactFontSize}px;">${contact.email}</span>
        </div>
      ` : '';

      return `
        <div style="
          background-color: #ffffff;
          border: 1px solid ${borderColor};
          border-radius: ${borderRadius}px;
          padding: 20px;
          text-align: center;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          margin-bottom: ${cardSpacing}px;
        ">
          ${avatarHTML}
          <h3 style="
            font-size: ${nameFontSize}px;
            color: ${nameColor};
            margin: 0 0 8px 0;
            font-weight: bold;
            font-family: ${fontFamily};
          ">${contact.fullName}</h3>
          <div style="
            font-size: ${positionFontSize}px;
            color: ${positionColor};
            margin: 0 0 15px 0;
            font-weight: 500;
            font-family: ${fontFamily};
          ">${contact.position}</div>
          ${contact.description ? `<p style="
            font-size: ${descriptionFontSize}px;
            color: ${descriptionColor};
            margin: 0 0 15px 0;
            line-height: 1.5;
            font-family: ${fontFamily};
          ">${contact.description}</p>` : ''}
          <div style="display: flex; flex-direction: column; gap: 8px;">
            ${phoneHTML}
            ${emailHTML}
          </div>
        </div>
      `;
    });

    // Создаем таблицу для лучшей совместимости с email клиентами
    const cardsPerRowNum = Math.min(cardsPerRow, contactsArray.length);
    const rows = [];
    for (let i = 0; i < contactsArray.length; i += cardsPerRowNum) {
      const rowCards = contactCards.slice(i, i + cardsPerRowNum);
      const cells = rowCards.map(card => `<td style="vertical-align: top; padding: 0 ${cardSpacing/2}px;">${card}</td>`).join('');
      rows.push(`<tr>${cells}</tr>`);
    }

    const cardsHTML = `
      <table style="width: 100%; border-collapse: collapse; max-width: 1200px; margin: 0 auto;">
        ${rows.join('')}
      </table>
    `;

    return `
    <!-- CONTACT US BLOCK -->
    <!--[if mso | IE]>
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px; text-align: ${alignment};">
    <![endif]-->
    
    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;">
        <tr>
            <td style="background-color: ${backgroundColor}; padding: ${padding}px; text-align: ${alignment};">
                ${titleHTML}
                ${cardsHTML}
            </td>
        </tr>
    </table>
    
    <!--[if mso | IE]>
            </td>
        </tr>
    </table>
    <![endif]-->`;
  }

  // Метод для скачивания HTML
  static downloadHTML(html, filename = 'email-template') {
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  // Метод для генерации CSS (для совместимости)
  static generateCSS(blocks, settings) {
    // Возвращаем минимальный CSS, так как основные стили теперь inline
    return `
/* Minimal CSS for email compatibility */
@media only screen and (max-width: 600px) {
  .mobile-stack-column {
    display: block !important;
    width: 100% !important;
  }
  .mobile-text-adjust {
    font-size: 16px !important;
  }
  .mobile-heading-adjust {
    font-size: 24px !important;
  }
  .mobile-image {
    width: 100% !important;
    max-width: 100% !important;
  }
}`;
  }
}

export default EmailExporterImproved;
